import { render, staticRenderFns } from "./BankSlips.vue?vue&type=template&id=09221af1&"
import script from "./BankSlips.vue?vue&type=script&lang=js&"
export * from "./BankSlips.vue?vue&type=script&lang=js&"
import style0 from "./BankSlips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports